"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombinedEventsTracker = void 0;
const CombinedEventsTracker = (trackers) => {
    return {
        async track(event) {
            for (const tracker of trackers) {
                await tracker.track(event);
            }
        },
    };
};
exports.CombinedEventsTracker = CombinedEventsTracker;
